import React, { Component } from 'react';
import { Portlet, PortletBody } from "../../../../partials/content/Portlet";
import PortletSpinner from "../../../../partials/layout/PortletSpinner";
import DataGridBase from "../../../../partials/layout/DataGridBase";
import { Badge } from "react-bootstrap";
import * as forecastCrud from '../../../../crud/forecast.crud';
import CustomFieldHelper from "../../_Helpers/CustomFieldHelper";
import { withListPageProps } from '../../../../shared/hoc/withListPageProps';
import ProjectOrderBatchModal from '../Batch/ProjectOrderBatchModal/ProjectOrderBatchModal';
import { notificationAggregateListTagsFilter, notificationUniqueTagsFilter, notificationUniqueTagsFilterV3 } from "../../../../store/helpers/FilterHelper";
import BaseListPage from '../../_CustomComponents/BaseListPage';

export const getBatchFormFields = (fields, wfid) => {
    const formFields = [];

    if (fields.Subject.visible) {
        formFields.push({
            caption: fields.Subject.label,
            dataField: 'subject',
            required: fields.Subject.required,
            dataType: 'string'
        })
    }

    if (fields.ForecastDate.visible) {
        formFields.push({
            caption: fields.ForecastDate.label,
            dataField: 'forecastdatedisplay',
            required: fields.ForecastDate.required,
            dataType: 'date'
        })
    }

    if (fields.Details.visible) {
        formFields.push({
            caption: fields.Details.label,
            dataField: 'description',
            required: fields.Details.required,
            dataType: 'long-string'
        })
    }

    if (fields.Type.visible) {
        formFields.push({
            caption: fields.Type.label,
            dataField: 'replycomment',
            required: fields.Type.required,
            dataType: 'list',
            options: {
                dataSource: fields.Type.clauses,
                valueExpr: 'display',
                displayExpr: 'display'
            }
        })
    }

    if (wfid == 52) {
        if (fields.CostForecast.visible) {
            formFields.push({
                caption: fields.CostForecast.label,
                dataField: 'newcostforecast',
                required: fields.CostForecast.required,
                dataType: 'money'
            });
        }
    } else {
        if (fields.Target.visible) {
            formFields.push({
                caption: fields.Target.label,
                dataField: 'target',
                required: fields.Target.required,
                dataType: 'decimal'
            })
        }
        if (fields.Forecast.visible) {
            formFields.push({
                caption: fields.Forecast.label,
                dataField: 'newcarbonforecast',
                required: fields.Forecast.required,
                dataType: 'decimal'
            })
        }
        if (fields.Actual.visible) {
            formFields.push({
                caption: fields.Actual.label,
                dataField: 'actual',
                required: fields.Actual.required,
                dataType: 'decimal'
            })
        }
        if (fields.Variance.visible) {
            formFields.push({
                caption: fields.Variance.label,
                dataField: 'variance',
                required: fields.Variance.required,
                dataType: 'decimal'
            })
        }
    }

    return formFields;
}

class ForecastListPage extends BaseListPage {
    constructor(props) {
        super(props);
        //this.props.fetchForecast(this.props.notificationType, true);

        this.notificationsTagsEnabled = process.env.REACT_APP_COMMUNICATION_TAG_ENABLED === 'true' && props.contract.specifictags?.length > 0;
        this.notificationsRelsEnabled = process.env.REACT_APP_COMMUNICATION_REL_ENABLED === 'true';
        this.customFields = [];
        if (props.customFields) {
            if (props.customFields.COMMUNICATION && props.customFields.COMMUNICATION.length > 0) {
                this.customFields.push(...(props.customFields.COMMUNICATION.filter(cf => cf.includelisting)));
            }
            if (props.customFields.REPLY && props.customFields.REPLY.length > 0) {
                this.customFields.push(...(props.customFields.REPLY.filter(cf => cf.includelisting)));
            }
        }

        this.forecastBatchEnabled = !!this.props.workflowsQA['87'];

        this.batchWorkflowItem = this.props.workflowsQA['87'];

        this.multipleProjectOrderWizardEnabled =
            this.forecastBatchEnabled
            && this.batchWorkflowItem?.userFilters?.mainNotice?.createAllowed;

        this.additionalButtons = [];
        if (this.multipleProjectOrderWizardEnabled && this.props.workflowItem.id === 52) {
            this.additionalButtons.push(
                {
                    location: "after",
                    locateInMenu: "auto",
                    widget: "dxButton",
                    options:
                    {
                        icon: "plus",
                        onClick: () => { this.setState({ projectOrderBatchModalVisible: true }) },
                        text: "Create Batch",
                    }
                }
            );
        }

        this.batchFormFields = getBatchFormFields(this.props.workflowItem.fields, this.props.workflowItem.id);

        this.state = {
            forecasts: null,
            tags: null,
            projectOrderBatchModalVisible: false
        };
    }
    componentDidMount() {
        super.componentDidMount();
        // this.fetchForecasts();
        this.fetchForecasts2();
    }
    // fetchForecasts = () => {
    //     const { companyid, projectid, contractid } = this.props.contract;
    //     forecastCrud.getForecasts(companyid, projectid, contractid, this.props.notificationType, this.props.accessibleWfIds)
    //         .then(response => {
    //             let listData = notificationAggregateListTagsFilter(JSON.parse(response.data.aggregatelist));
    //             listData = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true) ?
    //                 listData :
    //                 listData.filter(ntf => ntf.showtasknotification === 1);

    //             let tagFilters = notificationUniqueTagsFilter(JSON.parse(response.data.uniquetags));

    //             this.setState({ forecasts: listData, tags: tagFilters });
    //         })
    //         .catch(err => {
    //             this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
    //         });
    // }
    fetchForecasts2 = async () => {
        try {
            const { companyid, projectid, contractid } = this.props.contract;
            const { data: responseObj } = await forecastCrud.getForecastsReducedV2(
                companyid,
                contractid,
                this.props.workflowItem.config.currentModelType,
                this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed,
                this.props.accessibleWfIds);
            let forecasts = CustomFieldHelper.MapDataListCustomFieldsToObjectPropertiesV2(responseObj);

            forecasts = (this.props.workflowItem.userFilters.mainNotice.viewDraftAllowed === true
                && !this.multipleProjectOrderWizardEnabled) ?
                forecasts.filter(ntf => ntf.forecastbatchreference === null) ://draft notifications created from forecast batch should only be editable via forecast batch
                forecasts.filter(ntf => ntf.showtasknotification === 1);

            let tagFilters = notificationUniqueTagsFilterV3(this.props.communicationTags);
            this.setState({ forecasts, tags: tagFilters });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    onTableSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData.length > 0) {
            const data = selectedRowsData[0];
            const url = this.calculateUrl(data, true);
            this.props.navigate(url);
        }
    }
    calculateUrl = (rowData, skipHostUrl) => {
        return (skipHostUrl ? '' : process.env.PUBLIC_URL) + this.props.workflowItem.paths.basePath + rowData.forecastid;
    }
    renderStatusColumn = (cellInfo) => {
        let badgeVariant = cellInfo.data.showtasknotification === 1 ? 'success' : 'secondary';
        const displayText = this.calculateStatusValue(cellInfo.data);
        return (<Badge variant={badgeVariant}>{displayText}</Badge>);
    }
    calculateStatusValue = (rowData) => {
        return this.props.intl.formatMessage({ id: 'OPTIONS.STATUS.' + rowData.status });
    }
    calculateCarbonValue = (cellInfo) => {
        return cellInfo.data.newcarbonforecast + ' ' + this.props.intl.formatMessage({ id: 'GENERAL.FORMS.LABEL_TONNES' });
    }
    onProjectOrderBatchClosed = (refreshIndicator) => {
        this.setState({ projectOrderBatchModalVisible: false }, () => {
            if (refreshIndicator) {
                this.fetchForecasts2();
            }
        });
    }
    render() {
        if (!this.state.forecasts) {
            return (<PortletSpinner />);
        }

        const { fields } = this.props.workflowItem;

        const columns = [
            { resource: "GENERAL.FORMS.FIELD.ID", dataField: "referenceid", dataType: 'string', renderReferenceidLink: true },
            { resource: "GENERAL.FORMS.FIELD.SUBJECT", dataField: "subject" },
            { resource: "GENERAL.FORMS.FIELD.DETAILS", dataField: "description", isHtml: true },
            { resource: "GENERAL.FORMS.FIELD.COMMUNICATED_BY", dataField: "communicatedby" },
            { resource: "GENERAL.FORMS.FIELD.CREATED_BY", dataField: "createby", visible: false },
            { resource: "GENERAL.FORMS.FIELD.DRAFT_NOTIFIED_TO", dataField: "lastdraftednotifiedtoname", visible: false },

        ];

        if (this.props.notificationType === 'CostForecast') {
            columns.push({ resource: "GENERAL.FORMS.FIELD.COSTFORECAST", dataField: "newcostforecast", dataType: 'currency', currencyCode: this.props.contract.currency })
        } else {
            columns.push({ resource: "GENERAL.FORMS.FIELD.CARBONFORECAST", dataField: "newcarbonforecast", cellRender: this.calculateCarbonValue })
        }

        columns.push(
            //{ resource: "GENERAL.FORMS.FIELD.SUBTYPE", dataField: "replycomment" },
            { resource: "GENERAL.FORMS.FIELD.FORECASTDATE", dataField: "forecastdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.NOTIFIED_DATE", dataField: "notificationdate", dataType: 'date' },
            { resource: "GENERAL.FORMS.FIELD.STATUS", dataField: "status", cellRender: this.renderStatusColumn, calculateCellValue: this.calculateStatusValue },
            { resource: "GENERAL.FORMS.FIELD.LINK", dataField: "url", calculateCellValue: this.calculateUrl, visible: false, showInColumnChooser: false },
            { resource: "PROJECT.FIELD.CODE", dataField: "projectcode", visible: false },
            { resource: "PROJECT.FIELD.NAME", dataField: "project", visible: false },
            { caption: this.props.intl.formatMessage({ id: 'PAYMENTS.FIELD.PROJECTORDER_REFERENCE' }, { PROJECT_ORDER: this.props.globalResources.WF_72_NOTIFICATION_NAME }), dataField: "projectorderreference", visible: false }
        );

        if (this.forecastBatchEnabled) {
            columns.push(
                { resource: 'PAYMENTS.FIELD.BATCH_REFERENCE', dataField: 'forecastbatchreference' }
            );
        }

        if (fields.Type.visible) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.SUBTYPE", dataField: "replycomment" }
            )

        }
        if (this.props.workflowItem.assetFieldsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.ASSET_NAME", dataField: "assetname", visible: false },
                { resource: "GENERAL.FORMS.FIELD.ASSET_TYPE", dataField: "assettype", visible: false },
            );
        }
        if (this.notificationsTagsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.FIELD.PORTFOLIO", dataField: "tags_portfolio", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.PortfolioFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROGRAMME", dataField: "tags_programme", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProgrammeFilter } },
                { resource: "GENERAL.FORMS.FIELD.PROJECT", dataField: "tags_project", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.ProjectFilter } },
                { resource: "GENERAL.FORMS.FIELD.OTHER", dataField: "tags_other", visible: false, dataType: 'tag', headerFilter: { dataSource: this.state.tags.OtherFilter } }
            );
        };

        if (this.notificationsRelsEnabled) {
            columns.push(
                { resource: "GENERAL.FORMS.TAB_RELATIONS", dataField: "relatednotices", visible: false },
            )
        }
        columns.push(...CustomFieldHelper.MapCustomFieldsToDataGridColumns(this.customFields));


        return (
            <Portlet>
                <PortletBody>
                    <DataGridBase
                        version="1"
                        //BATCH OPS
                        batchOperations={true}
                        batchFormFields={this.batchFormFields}
                        batchImportEndpoint={forecastCrud.importForecasts}
                        batchDeleteEndpoint={forecastCrud.deleteForecastDrafts}
                        batchCommunicateEndpoint={forecastCrud.communicateForecastDrafts}
                        onBatchRecordsUpdated={this.fetchForecasts2}
                        customFields={this.props.customFields}
                        //BATCH OPS
                        title={this.props.intl.formatMessage({ id: 'GENERAL.REGISTER.TITLE2' }, { ITEM_NAME: this.props.workflowItem.pageTitle })}
                        createPath={this.props.workflowItem.userFilters.mainNotice.createAllowed ? this.props.workflowItem.paths.createPath : null}
                        workflowItem={this.props.workflowItem}
                        name={this.props.workflowItem.pageTitle}
                        dataSource={this.state.forecasts}
                        keyExpr="forecastid"
                        onSelectionChanged={this.onTableSelectionChanged}
                        hoverStateEnabled={true}
                        rowAlternationEnabled={false}
                        columns={columns}
                        additionalToolbarItems={this.additionalButtons}
                    />
                </PortletBody>
                {
                    this.multipleProjectOrderWizardEnabled && (
                        <ProjectOrderBatchModal
                            {...this.props}
                            workflowItem={this.batchWorkflowItem}
                            visible={this.state.projectOrderBatchModalVisible}
                            onClose={this.onProjectOrderBatchClosed}
                        />
                    )
                }
            </Portlet>
        );
    }
}


export default withListPageProps(ForecastListPage);
